import { Link } from "react-router-dom";

export function MagnetPlaceholder() {
  return (
    <section id="free-tool" className="border-y border-border bg-muted/30">
      <div className="container mx-auto px-4 py-16 text-center">
        <h2 className="mb-3 text-2xl font-semibold tracking-tight">
          Free ticker analysis — coming soon
        </h2>
        <p className="mx-auto max-w-xl text-muted-foreground">
          We're working on a free, no-signup ticker analysis tool you can try in
          seconds. Want early access?{" "}
          <Link to="/contact-us" className="text-primary hover:underline">
            Contact us
          </Link>{" "}
          and we'll let you know when it goes live.
        </p>
      </div>
    </section>
  );
}
